module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 5
// module chunks = 0